export default "__VITE_ASSET__DNvS9kaB__"